var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdcopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 11.5,
    transform: "matrix(-1 0 0 1 12 12)",
    fill: "white",
    stroke: "#1A6996"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1174 17L10.3374 15.188H6.82138L6.04138 17H4.04937L7.67338 8.612H9.48538L13.1094 17H11.1174ZM8.58538 11.108L7.52938 13.544H9.62938L8.58538 11.108ZM16.3304 17.096C15.5704 17.096 14.8904 16.772 14.2904 16.124C13.6904 15.476 13.3904 14.672 13.3904 13.712C13.3904 12.752 13.6824 11.968 14.2664 11.36C14.8504 10.744 15.5344 10.436 16.3184 10.436C17.1024 10.436 17.7424 10.712 18.2384 11.264V8.096H20.0384V17H18.2384V16.148C17.7344 16.78 17.0984 17.096 16.3304 17.096ZM15.2024 13.784C15.2024 14.304 15.3584 14.732 15.6704 15.068C15.9824 15.396 16.3464 15.56 16.7624 15.56C17.1784 15.56 17.5304 15.396 17.8184 15.068C18.1144 14.732 18.2624 14.304 18.2624 13.784C18.2624 13.256 18.1144 12.82 17.8184 12.476C17.5304 12.124 17.1744 11.948 16.7504 11.948C16.3264 11.948 15.9624 12.124 15.6584 12.476C15.3544 12.828 15.2024 13.264 15.2024 13.784Z",
    fill: "#1A6996"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdcopy);
export default __webpack_public_path__ + "static/media/adcopy.d288a740d774cd0b0539b2f7e0288e5f.svg";
export { ForwardRef as ReactComponent };